import { Component, Input, OnInit } from '@angular/core';

export class LegendElement{
  text   : string
  colors : string[]
}

@Component({
  selector: 'legenda',
  templateUrl: './legenda.component.html',
  styleUrls: ['./legenda.component.scss']
})
export class LegendaComponent implements OnInit {


  @Input('legends') legends: LegendElement 

  constructor() { }

  ngOnInit(): void {
  }

  getGradient( el: LegendElement){
    let gradient = "linear-gradient(90deg"
    el.colors.forEach(( color ) => {
      gradient += ` ,${color} ${(100/el.colors.length).toPrecision(2)}%`
    })
    gradient += ")"
    
    return { 'background': gradient } 
  }
}
